import Text from "@/app/(site)/_components/Atoms/Text"
import { FOCUS_VISIBLE_CLASS } from "@/src/utils/a11y/focusVisible"
import { clsx } from "@/src/utils/clsx"
import React from "react"
interface ButtonPillProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant: "primary" | "secondary" | "tertiary"
    color: "black" | "white"
    size: "large" | "medium" | "small"
    fullWidth?: boolean
    disabled?: boolean
    isCheckout?: boolean
    children: React.ReactNode
}

const baseStyles = clsx(
    "inline-flex items-center justify-center gap-8 rounded-full font-trimRegularNew font-light uppercase",
    "transition duration-300 ease-in-out",
    FOCUS_VISIBLE_CLASS
)
const sizeStyles = {
    large: "md:px-[24px] md:py-[16px] md:text-lg px-16 py-14 text-16 !leading-[18px]",
    medium: "px-16 py-16 text-16 !leading-[15px]",
    small: "px-16 py-13 text-sm !leading-[15px]"
}
const colorStyles = {
    primary: {
        black: "bg-black text-white hover:bg-opacity-90",
        white: "bg-white text-black hover:bg-opacity-90"
    },
    secondary: {
        black: "border border-black text-black hover:border-opacity-90",
        white: "border border-white text-white hover:border-opacity-90"
    },
    tertiary: {
        black: "bg-transparent border border-black text-black hover:bg-opacity-10",
        white: "bg-transparent border border-white text-white hover:bg-opacity-10"
    }
}
const fullWidthStyles = "w-full"
const disabledStyles =
    "opacity-50 cursor-not-allowed bg-main-medium-grey hover:bg-main-medium-grey !text-main-black line-through"
const disabledStylesAlternative = "cursor-not-allowed "

const ButtonPill: React.FC<ButtonPillProps> = ({
    variant,
    color,
    size,
    fullWidth,
    disabled,
    isCheckout,
    className,
    children,
    ...rest
}) => {
    const textSize = size === "large" ? "medium" : "small"
    const buttonStyles = clsx(
        baseStyles,
        sizeStyles[size],
        colorStyles[variant][color],
        { [fullWidthStyles]: fullWidth },
        disabled && (isCheckout ? disabledStyles : disabledStylesAlternative),
        className
    )

    return (
        <Text size={textSize} weight="regular" asChild>
            <button className={buttonStyles} disabled={disabled} {...rest}>
                {children}
            </button>
        </Text>
    )
}

export default ButtonPill
